import axios from 'axios';
import { signCrypto } from "@/utils/generateSecretKey";
import { message } from 'antd';

axios.defaults.baseURL = 'http://www.jsic.cn/api/';

axios.interceptors.request.use((config) => {
  return config;
})

axios.interceptors.response.use(config => {
  return config;
})

const http = {
  post: '',
  get: '',
  put: '',
  del: '',
  baseURL: 'http://www.jsic.cn/'
}

http.post = function (api, data) {
  data.signField = Object.keys(data);
  let nData = signCrypto(data);
  return new Promise((resolve, reject) => {
    axios.post(api, nData).then(response => {
      resolve(response)
    })
  })
}

http.get = function (api, data) {
  // console.log(data);
  data.signField = Object.keys(data);
  // console.log(data.signField);
  let params = signCrypto(data);
  return new Promise((resolve, reject) => {
    axios.get(api, { params }).then(response => {
      if (response.status !== 200) {
        // return message.error(response.statusText || "请求出错！")
      } else if (response.status === 200 && response.data.error_code !== 0) {
        // return message.error(response.data.error_msg || "请求出错！")
      } else if (response.status === 200 && response.data.error_code === 0) {
        resolve(response.data)
      }
    })
  })
}

http.delete = function (api, data) {
  data.signField = Object.keys(data);
  let nData = signCrypto(data);
  return new Promise((resolve, reject) => {
    axios.delete(api, nData).then(response => {
      resolve(response)
    })
  })
}

http.put = function (api, data) {
  data.signField = Object.keys(data);
  let nData = signCrypto(data);
  return new Promise((resolve, reject) => {
    axios.put(api, nData).then(response => {
      resolve(response)
    })
  })
}

export default http